import { AnimationEvent } from "@angular/animations";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  forwardRef
} from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";

import { AbstractFormControlComponent } from "@lantern/app/common/forms/abstract-form-control/abstract-form-control.component";
import { treeAnimations } from "./json-tree-animations";

@Component({
  selector: "ta-json-value-editor",
  templateUrl: "./json-value-editor.template.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => JsonValueEditorComponent),
      multi: true
    }
  ],
  animations: treeAnimations
})
export class JsonValueEditorComponent extends AbstractFormControlComponent<
  string | number | boolean
> {
  @Input()
  isLastChild: boolean;

  @Input()
  key: string;

  @Input()
  animate: boolean = false;

  @Output()
  delete = new EventEmitter();

  hovered = false;

  expansionTime = "0s";

  get inputType(): "text" | "number" | "boolean" | undefined {
    if (typeof this.value === "string") {
      return "text";
    }
    if (typeof this.value === "number") {
      return "number";
    }

    if (typeof this.value === "boolean") {
      return "boolean";
    }
  }

  toggleBoolean(): void {
    this.value = !this.value;
  }

  handleAnimationDone(event: AnimationEvent): void {
    // this forces the underlying input to re-calculate
    // its width AFTER the grow-in animation
    if (event.toState === "added" && event.totalTime > 0) {
      this.refreshValue();
    }
  }

  refreshValue(): void {
    setTimeout(() => {
      const savedValue = this.value;
      this.value = "";

      setTimeout(() => {
        this.value = savedValue;
        this.temporarilySlowExpansionTime();
      }, 0);
    }, 0);
  }

  temporarilySlowExpansionTime(): void {
    this.expansionTime = "500ms";

    setTimeout(() => {
      this.expansionTime = "0s";
    }, 500);
  }
}
